import { useMutation } from '@tanstack/react-query';
import { apiPost } from '@services/api';

// Suggest task improvements
export function useSuggestTask() {
  return useMutation({
    mutationFn: async ({ title, context }) => {
      const response = await apiPost('/ai/suggest-task', { title, context });
      return response.data;
    },
  });
}

// Generate sprint summary
export function useSprintSummary() {
  return useMutation({
    mutationFn: async (sprintId) => {
      const response = await apiPost('/ai/sprint-summary', { sprintId });
      return response.data;
    },
  });
}

// Estimate task
export function useEstimateTask() {
  return useMutation({
    mutationFn: async ({ title, description, type }) => {
      const response = await apiPost('/ai/estimate', { title, description, type });
      return response.data;
    },
  });
}
